module.exports = __webpack_public_path__ + "img/zmoaimage.e2404dff.png";